<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          {{ dataId ? '查看' : '新增' }}知识文档
        </div>
        <div class="fr">
          <el-button v-if="(basKnowledgeAdd && formData.id == null) || (basKnowledgeEdit && formData.id != null)"
            type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item" style="position: relative;">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
                <tr>

                  <th>
                    <em class="f-red">*</em>
                    知识库分类
                  </th>
                  <td>
                    <el-cascader :props="{ value: 'id', label: 'typeName', children: 'children', leaf: 'hasChild' }"
                      v-model="knowledgeTypeIdList" :options="knowledgeTypeOption" @change="handleChange"></el-cascader>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    标题
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.title" clearable />
                  </td>
                  <th>
                    关键字
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.keyWords" clearable />
                  </td>

                  <th>
                    <em class="f-red">*</em>
                    是否置顶
                  </th>
                  <td>
                    <el-select v-model="formData.isTop">
                      <el-option label="否" :value="0" />
                      <el-option label="是" :value="1" />
                    </el-select>
                  </td>
                </tr>

                <tr>
                  <th>
                    <em class="f-red">*</em>
                    是否发布
                  </th>
                  <td>
                    <el-select v-model="formData.isPublic">
                      <el-option label="否" :value=0></el-option>
                      <el-option label="是" :value=1></el-option>
                    </el-select>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    使用渠道
                  </th>
                  <td>
                    <el-select v-model="useChannels" clearable multiple placeholder="请选择">
                      <el-option label="app" :value=1></el-option>
                      <el-option label="小程序" :value=2></el-option>
                      <el-option label="其他" :value=3></el-option>
                    </el-select>
                  </td>
                  <th>
                    资料链接
                  </th>
                  <td colspan="3">
                    <el-input type="text" autocomplete="off" v-model="formData.linkUrl" clearable />
                  </td>
                  <th>主图</th>
                  <td colspan="">
                    <div class="form_picture">
                      <div>
                        <photoUpload :photo-url.sync="formData.vizKnowledge" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr style="margin-top: 8px">
                  <th>创建人</th>
                  <td>{{ formData.createBy }}</td>
                  <th>创建时间</th>
                  <td>{{ formData.createTime }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-item" style="height: 280px; ">
            <el-row :gutter="40">
              <el-col :span="7">
                <div class="title first">
                  <b>附件信息</b>
                  <el-upload style="display:flex; margin-top: -6px; float: right" class="upload-demo" ref="upload"
                    :action="api.uploadFileUrl" accept=".docx,.doc,.txt,.pdf,.xlsx,.mp4,.avi" v-if="basKnowledgeEdit && fileList.length < 5"
                    :show-file-list="false"
                    :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }" :headers="headers"
                    :on-progress="upVideo"
                    :auto-upload="true">
                    <el-button type="primary" class="button-sty btn_zdy2">
                      <i class="el-icon-plus"></i>
                      附件
                    </el-button>
                  </el-upload>
                </div>
                <div class="current-info">
                  <vxe-table ref="filterTable" class="table_item pic_item mytable-scrollbar"
                    :column-config="{ resizable: true }" style="width: 100%;" :stripe="true"
                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                    show-overflow :data="fileList">
                    <vxe-column field="name" title="附件名称" width="">
                      <template #default="{ row }">
                        <!-- <a :href="row.url" :download="row.name">{{row.name}}</a> -->
                        <span @click="openVideo(row.url)">{{ row.name }}</span>

                      </template>
                    </vxe-column>
                    <vxe-column title="操作" width="90">





                      <template #default="{ row }">
                        <!-- 下载 -->
                        <div>

                        </div>

                        <div>
                          <el-tooltip v-if="basKnowledgeEdit" :enterable="false" effect="dark" content="删除" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="deleteFile(row)" class="el-icon-delete"
                              style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>

                          <el-tooltip v-if="basKnowledgeEdit" :enterable="false" effect="dark" content="下载" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="handleDownload(row.name, row.url)" class="el-icon-download"
                              style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>

                          <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
      popper-class="tooltip-skin">
      <i @click="openVideo(row.url)" class="el-icon-view"
        style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
    </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="title first">
                  <b>产品分类</b>
                </div>
                <div>
                  <vxe-table ref="treeTable"
                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{ height: 30, isHover: true, padding: 0, }"
                    :checkbox-config="{ checkStrictly: false, checkRowKeys: selectedItemCategoryList, showHeader: true }"
                    :row-style="{ fontSize: '12px', }" show-overflow row-id="id" height="220"
                    :column-config="{ resizable: true }" resizable
                    :tree-config="{ transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasChild' }"
                    :data="tableData" @checkbox-change="selectChangeEvent" @checkbox-all="selectChangeEvent">
                    <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                    <vxe-column field="categoryName" width="" title="产品大类"></vxe-column>
                  </vxe-table>
                </div>
              </el-col>
              <el-col :span="10">
                <div class="title first" style="display: flex;flex-direction: row; justify-content: space-between;">
                  <b>故障现象</b>
                  <div class="item-button">
                    <el-button v-if="basKnowledgeEdit" type="primary" class="button-sty btn_zdy" @click="openPop">
                      <i class="el-icon-plus"></i>
                      故障现象
                    </el-button>&nbsp;
                    <el-button v-if="basKnowledgeEdit" type="primary" class="button-sty btn_zdy" @click="handleDeleteList">
                      <i class="el-icon-delete"></i>
                      批量删除
                    </el-button>
                  </div>
                </div>
                <div class="current-info">
                  <vxe-table ref="filterTable" height="220" class="table_item pic_item mytable-scrollbar"
                    :column-config="{ resizable: true }" style="width: 100%;" :stripe="true"
                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                    show-overflow :data="formData.basKnowledgeFaultList" @checkbox-all="selectChangeEvent1"
                    @checkbox-change="selectChangeEvent1">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="symptomCode" title="故障现象编码" />
                    <vxe-column field="symptomName" title="故障现象名称" />
                    <vxe-column title="操作" width="60">
                      <template #default="{ row }">
                        <div @click="handleDeleteSymptom(row.id)">
                          <el-tooltip v-if="basKnowledgeEdit" :enterable="false" effect="dark" content="删除" placement="top"
                            popper-class="tooltip-skin">
                            <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="d-item" style="height: 46vh; ">
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="title first">
                  <b style="margin-left: 0px;">内容</b>
                </div>
                <div>
                  <quill-editor class="editor" ref="myTextEditor" v-model="formData.content" :options="editorOption"
                    @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)"
                    @change="onEditorChange($event)">
                  </quill-editor>
                </div>
              </el-col>
            </el-row>


          </div>
        </div>

      </div>
    </el-form>
    <faultSymptomPop v-if="showPop" :visiable.sync="showPop" multi="true" @confirm="commit" :excludeIdList="excludeIdList"
      :param="{ itemCategoryIdList: selectedItemCategoryList }" />

    <el-dialog :visible.sync="imgVisble" width="50%" class="imgVisble" :close-on-click-modal="false">
      <iframe :src="imgVisbleURL" frameborder="0" width="100%" height="600"></iframe>
    </el-dialog>
    <!-- 文件预览 -->
    <Preview v-if="showPreview" @closeD="closeD" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />
  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce';
import store from "@/store";

import api from "@/api/projectApi";
import { editPageMixins } from "@/mixins/tabChang";
import { mapGetters } from 'vuex';
import faultSymptomPop from "@/views/dialogCommon/checkboxFaultSymptomDialog.vue";
// 文件预览
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
import photoUpload from "@/components/formItem/photoUpload.vue"



// toolbar标题
const titleConfig = [
  { Choice: '.ql-insertMetric', title: '跳转配置' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-header', title: '段落格式' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code', title: '插入代码' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-font', title: '字体' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-direction', title: '文本方向' },
  { Choice: '.ql-header[value="1"]', title: 'h1' },
  { Choice: '.ql-header[value="2"]', title: 'h2' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-video', title: '视频' },
  { Choice: '.ql-upload', title: '文件' },

  { Choice: '.ql-link', title: '添加链接' },
  { Choice: '.ql-formula', title: '插入公式' },
  { Choice: '.ql-clean', title: '清除字体格式' },
  { Choice: '.ql-script[value="sub"]', title: '下标' },
  { Choice: '.ql-script[value="super"]', title: '上标' },
  { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
  { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
  { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
  { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
  { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
  { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
  { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
  { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
  { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
  { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
  { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
  { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
  { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
  { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
  { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
]
export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Preview,
    faultSymptomPop,
    Tinymce,
    photoUpload,
  },
  data() {
    return {
      imgVisbleURL: '',
      basKnowledgeAdd: false,
      showPreview: false,
      justShow:false,
      basKnowledgeEdit: false,
      imgVisble: false,
      showPop: false,
      excludeIdList: [],
      selectedIdList: [],
      formData: {
        knowledgeTypeId: null,  // 知识库分类ID,关联bas_knowledge_type.id
        title: null,  // 标题
        keyWords: null,  // 关键字
        isTop: 0,  // 是否置顶:0否1是
        isPublic: 1,  // 是否发布:0否1是
        content: null,  // 内容;注意为富文本
        selectedItemCategoryList: [],
        file1: null,
        file2: null,
        file3: null,
        file4: null,
        file5: null,
        basKnowledgeFaultList: [],
        pic:null,
        useChannels: ''
      },
      useChannels: [],
      fileList: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      selectedItemCategoryList: [],
      selectedBasKnowledgeFaultList: [],
      knowledgeTypeOption: [],
      knowledgeTypeIdList: [],
      tableData: [],


      img_b: "",
      upload_btn: false, // 是否隐藏上传图片按钮
      radio: '1',
      showEdit: false,
      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      intValueSplit: '',
      // 基本信息
      service: {
        pic: '',
      },
      tenant: {
        status: 0,
        tenantAttachmentDTOs: [],
        projectCode: '',
        projectName: '',
        valueType: 1,
        valueSplit: '',
        usable: 1,
        seq: 0
      },
      showProductCategoryDialog: false,
      editorOption: {
        modules: {
          toolbar: [

            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
            [{ script: "sub" }, { script: "super" }], // 上标/下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            // [{'direction': 'rtl'}],                         // 文本方向
            [{ size: ["small", false, "large", "huge"] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            [{ font: [] }], // 字体种类
            [{ align: [] }], // 对齐方式
            ["clean"], // 清除文本格式
            ["link", "image", "video", "upload"] // 链接、图片、视频
          ], //工具菜单栏配置
        },
        placeholder: '请在这里添加产品描述', //提示
        readyOnly: false, //是否只读
        theme: 'snow', //主题 snow/bubble
      }
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    editor() {
      return this.$refs.myTextEditor.quillEditor;
    },
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    },
  },
  created() {

    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  mounted() {
    this.initTitle()
    this.getData()
    this.loadKnowledgeType()


    this.basKnowledgeAdd = this.permissions['basKnowledgeAdd']
    this.basKnowledgeEdit = this.permissions['basKnowledgeEdit']
    this.justShow = this.permissions['justShow']

  },
  watch: {
    'formData.basKnowledgeFaultList': {
      handler(n) {
        console.log('98374895234')
        if (n) {
          this.excludeIdList = n.map(item => item.id)
        } else {
          this.excludeIdList = []
        }
      }
    }
  },
  methods: {
    closeD() {
      this.showPreview = false

    },
    // 文件下载
    handleDownload(Vname, Vurl) {
      console.log(Vname, Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
    // 文件预览
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },

    openPop() {
      if (this.selectedItemCategoryList != null && this.selectedItemCategoryList.length > 0) {
        this.showPop = true
      } else {
        this.$message.error('请先选中产品分类')
      }
    },

    // 关联故障现象删除
    handleDeleteSymptom(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log('deleteId', id)
        let symptomList = this.formData.basKnowledgeFaultList
        symptomList = symptomList.filter(item => item.id != id)
        this.formData.basKnowledgeFaultList = symptomList
      })
    },

    // 关联故障现象批量删除
    handleDeleteList() {
      let selectedIdList = this.selectedIdList
      if (selectedIdList != null && selectedIdList.length > 0) {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          let symptomList = this.formData.basKnowledgeFaultList
          console.log('deleteIdList', selectedIdList)
          console.log('symptomList', symptomList)
          selectedIdList.forEach(item => {
            symptomList = symptomList.filter(item1 => item1.id != item)
          })
          this.formData.basKnowledgeFaultList = symptomList
        })
      } else {
        this.$message.error('请先选中数据')
      }
    },


    commit(data) {
      console.log('故障现象选中', data)
      if (!this.formData.basKnowledgeFaultList) {
        this.formData.basKnowledgeFaultList = []
      }
      this.formData.basKnowledgeFaultList.push(...data)
    },


    handleFileSuccess(res, file, fileList) {


      let url = res.data.url
      let fileName = file.name
      console.log(url, "url")
      console.log(fileName, "name")
      this.fileList.push({
        name: fileName,
        url: url
      })
      this.$message({
          message: '附件上传成功',
          type: 'success'
        });
        this.$mask.close()


    },
    upVideo(){
      this.$mask.open()

    },

    deleteFile(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'delete')
        this.fileList = this.fileList.filter(item => item.url !== row.url)
      })
    },



    selectChangeEvent({ records }) {
      this.selectedItemCategoryList = records.map(item => item.id)
      this.selectedIdList = []
      this.formData.basKnowledgeFaultList = []
    },

    selectChangeEvent1({ records }) {
      this.selectedIdList = records.map(item => item.id)
    },

    initData() {
      this.$http({
        url: api.basKnowledge.initDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.tableData = res.data.data.basItemCategoryList
        if (this.selectedItemCategoryList) {
          this.selectedItemCategoryList.forEach(item => {
            if (item == 0) {
              setTimeout(() => {
                this.$refs.treeTable.setAllCheckboxRow(true)
              }, 500)

            }
          })
        } else {
          this.selectedItemCategoryList = []
        }
      })
    },

    loadKnowledgeType() {
      this.$http({
        url: api.basKnowledgeType.getOptionData,
        method: 'post',
        data: {}
      }).then(res => {
        this.knowledgeTypeOption = res.data.data
      })
    },

    echoKnowledgeType() {
      this.$http({
        url: api.basKnowledgeType.echoCascaderDataUrl,
        method: 'post',
        data: { id: this.formData.knowledgeTypeId }
      }).then(res => {
        this.knowledgeTypeIdList = res.data.data
      })
    },

    handleChange() {

    },


    initTitle() {
      document.getElementsByClassName('ql-editor')[0].dataset.placeholder = ''
      for (let item of titleConfig) {
        let tip = document.querySelector('.quill-editor ' + item.Choice)
        if (!tip) continue
        tip.setAttribute('title', item.title)
      }
    },
    // 失去焦点
    onEditorBlur(editor) {
    },
    // 获得焦点
    onEditorFocus(editor) {
    },
    // 开始
    onEditorReady(editor) {
    },
    // 值发生变化
    onEditorChange(editor) {
      this.content = editor.html;
      console.log(editor);
    },


    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http.post(api.basKnowledge.getDataUrl, { id: this.dataId }).then(response => {
          let data = response.data.data;
          this.formData = data
          if(this.formData.useChannels){
            this.useChannels = this.formData.useChannels.split(';').map(el => Number(el))
          }

          this.fileList = []
          if (data.file1) {
            this.fileList.push({ url: data.file1, name: data.fileName1 })
          }
          if (data.file2) {
            this.fileList.push({ url: data.file2, name: data.fileName2 })
          }
          if (data.file3) {
            this.fileList.push({ url: data.file3, name: data.fileName3 })
          }
          if (data.file4) {
            this.fileList.push({ url: data.file4, name: data.fileName4 })
          }
          if (data.file5) {
            this.fileList.push({ url: data.file5, name: data.fileName5 })
          }

          this.selectedItemCategoryList = this.formData.selectedItemCategoryList
          console.log(this.selectedItemCategoryList, 'list')
          this.echoKnowledgeType()
          this.initData()
        })
      } else {
        this.initData()
      }
    },
    saveData() {
      if (this.knowledgeTypeIdList.length == 0) {
        this.$message.warning('知识库分类不能为空')
        return
      } else {
        this.formData.knowledgeTypeId = this.knowledgeTypeIdList[this.knowledgeTypeIdList.length - 1]
      }

      if (this.selectedItemCategoryList && this.selectedItemCategoryList.length > 0) {
        this.formData.selectedItemCategoryList = this.selectedItemCategoryList
      } else {
        this.$message.error('请选择产品分类')
        return
      }

      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()

        console.log(this.fileList, 'fileList')
        if (this.fileList) {
          this.formData.file1 = null
          this.formData.fileName1 = null
          this.formData.file2 = null
          this.formData.fileName2 = null
          this.formData.file3 = null
          this.formData.fileName3 = null
          this.formData.file4 = null
          this.formData.fileName4 = null
          this.formData.file5 = null
          this.formData.fileName5 = null

          let length = this.fileList.length
          if (length >= 1) {
            this.formData.file1 = this.fileList[0].url
            this.formData.fileName1 = this.fileList[0].name
          }
          if (length >= 2) {
            this.formData.file2 = this.fileList[1].url
            this.formData.fileName2 = this.fileList[1].name
          }
          if (length >= 3) {
            this.formData.file3 = this.fileList[2].url
            this.formData.fileName3 = this.fileList[2].name
          }
          if (length >= 4) {
            this.formData.file4 = this.fileList[3].url
            this.formData.fileName4 = this.fileList[3].name
          }
          if (length >= 5) {
            this.formData.file5 = this.fileList[4].url
            this.formData.fileName5 = this.fileList[4].name
          }
        }

        // 全选保存为0
        if (this.$refs.treeTable.isAllCheckboxChecked()) {
          this.formData.selectedItemCategoryList = [0]
        }

        if(this.useChannels) {
          this.formData.useChannels = this.useChannels.join(';')
        }

        var url = (this.isEdit ? api.basKnowledge.updateDataUrl : api.basKnowledge.addDataUrl);
        this.$http.post(url, this.formData).then(res => {
          this.$message.success("保存成功！")
          this.goBackIndex()
          this.$mask.close()

        }).catch(e => {
          console.error(e)
          this.$message.error("保存失败！")
          this.$mask.close()

        });
      })
    },

  },
};

</script>
<style lang="scss" scoped>
.editor {
  line-height: normal !important;
  height: 235px;
  // margin-top: 10px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
  content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: '保存';
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-tooltip[data-mode=upload]::before {
  content: "请输入文件地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: '等宽字体';
}

//.papers {
//  margin-left: 20px;
//  position: absolute;

::v-deep.el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 147px !important;
  //margin-right: 14px;
  border-radius: 2px;
  border-color: #e8e8e8;
  margin-top: 7px;
  //margin-left: 15px;
  padding: 0px !important;
  background-color: #e1e1e1;
  height: 30px;
}

//}

::v-deep .btn_zdy {
  margin: 0 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  height: 30px;
  margin: 2px 0 0;
}

//::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-name {
//  margin-left: 3px;
//  padding: 0;
//}
//::v-deep .el-upload-list .el-upload-list__item {
//  width: 100px;
//  background-color: #e7e7ea !important;
//}
::v-deep .el-upload-list .el-upload-list__item {
  width: 100px;
  padding: 0;
  background-color: #e7e7ea !important;
}</style>
